import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import BonusCodes from './BonusCodes.vue';

const bonusCodesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/bonus-codes'),
      name: 'bonus_codes_index',
      meta: {
        permissions: ['administrator', 'bulk_message_manage'],
        featureFlag: FEATURE_FLAGS.BONUS_CODES,
      },
      component: BonusCodes,
    },
  ],
};

export default bonusCodesRoutes;
